import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-summary-carousel',
  templateUrl: './generic-summary-carousel.component.html',
  styleUrls: ['./generic-summary-carousel.component.css']
})
export class GenericSummaryCarouselComponent implements OnInit {

  @Input() type: string;
  @Input() title: string;
  @Input() amount: number;
  @Input() data: any;
  @Input() viewAllLink: string;
  @Input() inviteMember: string;

  constructor() { }

  ngOnInit(): void {
  }

}
